import React from 'react';
import PropTypes from 'prop-types';
import { PetDetailsPropTypes } from '../../../propTypes/petDetails';
import { PetProfileEditor } from '../../petProfileEditor/petProfileEditor';
import { PolicyDetailsList } from '../policyDetailsList/policyDetailsList';

import './petPolicyDetailsPanel.scss';
import { PetPolicyLinksBar } from '../petPolicyLinksBar/petPolicyLinksBar';

export const PetPolicyDetailsPanel = ({ petDetail }) => {
  return (
    <section className="petPolicySection">
      <div className="petPolicyDetailsPanel">
        <PetProfileEditor petDetail={petDetail} />
        <PolicyDetailsList
          policyDetails={petDetail.PolicyDetails}
          FullPolicyNumber={petDetail.FullPolicyNumber}
          PartnerNumber={petDetail.PartnerNumber}
        />
      </div>
      <PetPolicyLinksBar petDetail={petDetail} />
    </section>
  );
};

PetPolicyDetailsPanel.propTypes = {
  petDetail: PropTypes.shape(PetDetailsPropTypes)
};
